













































import Vue from "vue";
import { Messages } from "@/constants/messages";
export default Vue.extend({
  name: "URLInput",
  data(): {
    invalidField: boolean;
    errorMessage: string;
    valueField: string;
    mess: any;
  } {
    return {
      invalidField: false,
      errorMessage: "",
      valueField: "",
      mess: Messages,
    };
  },
  methods: {
    validateField(): boolean {
      const regex = /https:\/\/.+/;
      if (this.valueField !== ""&&!regex.exec(this.valueField)) {
        this.invalidField = true;
        this.errorMessage = this.label + this.mess.regApp_url__error;
        return false;
      }
      if (this.isOptional) {
        return true;
      }
      if (this.valueField === "") {
        this.invalidField = true;
        this.errorMessage = this.label + this.mess.error_mandatory;
        return false;
      }
      this.invalidField = false;
      this.errorMessage = "";
      return true;
    },
    emitValue() {
      this.$emit("input", this.valueField);
    },
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    tooltipText: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    maxLength: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    isOptional: {
      type: Boolean,
      default: false,
    },
  },
});
